import React, { useEffect, useState } from 'react';
import { UsersIcon, ShieldCheckIcon, LockIcon, CheckCircleIcon } from 'lucide-react';
export function CTASection() {
  const [checkoutUrl, setCheckoutUrl] = useState('https://pay.hotmart.com/O104784347F?checkoutMode=10');
  useEffect(() => {
    try {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift() || '';
        return '';
      };
      const urlParams = new URLSearchParams(window.location.search);
      const utm_source = urlParams.get('utm_source') || '';
      const utm_campaign = urlParams.get('utm_campaign') || '';
      const utm_content = urlParams.get('utm_content') || '';
      const utm_term = urlParams.get('utm_term') || '';
      const fbclid = urlParams.get('fbclid') || '';
      const trackingParts = [utm_term || 'organico', utm_campaign || 'sin_campana', utm_content || 'sin_adset', utm_source || 'sin_source'];
      const trackingString = trackingParts.join('|');
      const fbp = getCookie('_fbp');
      const fbc = getCookie('_fbc') || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : '');
      const finalUrl = new URL('https://pay.hotmart.com/O104784347F');
      finalUrl.searchParams.set('checkoutMode', '10');
      finalUrl.searchParams.set('src', trackingString);
      finalUrl.searchParams.set('sck', trackingString);
      if (fbp) finalUrl.searchParams.set('fbp', fbp);
      if (fbc) finalUrl.searchParams.set('fbc', fbc);
      setCheckoutUrl(finalUrl.toString());
    } catch (error) {
      console.error('Error generating tracking URL', error);
    }
  }, []);
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    try {
      // @ts-ignore
      if (window.fbq) {
        // @ts-ignore
        window.fbq('track', 'InitiateCheckout', {
          content_name: 'Carisma al Instante',
          currency: 'USD',
          value: 6.37
        });
      }
    } catch (error) {
      console.error('Pixel error', error);
    }
    // Fallback de seguridad: Redirigir después de 300ms para asegurar el envío del evento
    setTimeout(() => {
      window.location.href = checkoutUrl;
    }, 300);
  };
  return <section id="cta-section" className="py-16 bg-surface-deepest relative overflow-hidden border-t border-surface-border" data-id="element-11">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-red-600/5 rounded-full blur-[100px] pointer-events-none" data-id="element-12"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        {/* Value Stack Section */}
        <div className="text-center mb-12" data-id="element-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-2 italic" data-id="element-15">
            Esto es todo lo que te llevas hoy:
          </h2>
        </div>

        <div className="max-w-2xl mx-auto mb-12 space-y-4" data-id="element-16">
          {[{
          name: 'Manual Premium: Carisma al Instante',
          value: '$200 MXN',
          highlight: true,
          subItems: ['Lectura de lenguaje corporal', 'Técnicas de contacto visual', 'Posicionamiento de alto valor']
        }, {
          name: 'BONO 1: Protocolo de Atracción en Redes',
          value: '$150 MXN',
          highlight: false,
          subItems: []
        }, {
          name: 'BONO 2: Acceso a chat personalizado para tus dudas con Eduardo',
          value: '$150 MXN',
          highlight: false,
          subItems: []
        }].map((item, index) => <div key={index} className={`py-5 px-6 rounded-xl border transition-all duration-300 ${item.highlight ? 'bg-gold/5 border-gold/40 shadow-lg shadow-gold/5' : 'bg-surface-card/50 border-surface-border hover:border-gold/20'}`} data-id="element-17">
              <div className="flex items-center justify-between" data-id="element-18">
                <div className="flex items-center gap-3" data-id="element-19">
                  <CheckCircleIcon className={`w-6 h-6 flex-shrink-0 ${item.highlight ? 'text-gold' : 'text-gold/70'}`} data-id="element-20" />
                  <span className={`font-body text-base md:text-lg font-medium ${item.highlight ? 'text-white' : 'text-gray-200'}`} data-id="element-21">
                    {item.name}
                  </span>
                </div>
                <div className="flex flex-col items-end ml-4" data-id="element-22">
                  <span className={`font-body text-sm md:text-base whitespace-nowrap line-through ${item.highlight ? 'text-red-400 font-semibold' : 'text-gray-500'}`} data-id="element-23">
                    {item.value}
                  </span>
                  <span className={`font-body text-sm font-bold whitespace-nowrap ${item.highlight ? 'text-green-400' : 'text-green-500'}`} data-id="element-24">
                    {item.highlight ? '$132 MXN' : 'GRATIS'}
                  </span>
                </div>
              </div>
              {item.subItems && item.subItems.length > 0 && <div className="mt-3 ml-9 space-y-1.5" data-id="element-25">
                  {item.subItems.map((sub, i) => <p key={i} className="font-body text-sm text-gray-400 flex items-center gap-2" data-id="element-26">
                      <span className="w-1.5 h-1.5 bg-gold/60 rounded-full flex-shrink-0" data-id="element-27"></span>
                      {sub}
                    </p>)}
                </div>}
            </div>)}
        </div>

        {/* Gold Divider */}
        <div className="flex items-center justify-center max-w-2xl mx-auto mb-12" data-id="element-28">
          <div className="flex-1 h-px bg-gold/30" data-id="element-29"></div>
          <div className="w-2 h-2 bg-gold rounded-full mx-4" data-id="element-30"></div>
          <div className="flex-1 h-px bg-gold/30" data-id="element-31"></div>
        </div>

        {/* Price Box */}
        <div className="text-center" data-id="element-32">
          <div className="bg-surface-card border border-gold/30 rounded-2xl p-8 md:p-12 shadow-2xl shadow-gold/5 max-w-2xl mx-auto" data-id="element-33">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-34">
              Carisma al Instante — Paquete Completo
            </h3>
            <p className="font-body text-gray-400 mb-6" data-id="element-35">
              Acceso digital inmediato + Todos los bonus exclusivos
            </p>

            <div className="mb-2" data-id="element-36">
              <p className="font-body text-red-500 font-bold text-lg" data-id="element-37">
                VALOR TOTAL: <span className="line-through" data-id="element-38">$500 MXN</span>
              </p>
            </div>

            <div className="mb-8" data-id="element-39">
              <p className="font-body text-sm text-gold-light uppercase tracking-widest mb-1" data-id="element-40">
                Precio de Re-Lanzamiento
              </p>
              <div className="flex justify-center items-baseline" data-id="element-41">
                <span className="text-6xl md:text-7xl font-bold text-gold font-heading" data-id="element-42">
                  $132
                </span>
                <span className="text-2xl text-gold-light ml-2 font-body" data-id="element-43">
                  MXN
                </span>
              </div>
            </div>

            <a href={checkoutUrl} onClick={handleCheckoutClick} className="w-full py-5 bg-red-600 hover:bg-red-700 text-white font-body font-bold text-lg md:text-xl rounded-xl transition-all duration-300 animate-heartbeat animate-pulse-red flex items-center justify-center mb-4 shadow-lg shadow-red-600/20" data-id="element-44">
              SÍ, QUIERO SER UN HOMBRE MAGNÉTICO →
            </a>

            <div className="flex flex-col items-center justify-center space-y-1 mb-8" data-id="element-45">
              <p className="text-green-500 font-body font-bold text-sm md:text-base" data-id="element-46">
                (Pago único, acceso vitalicio)
              </p>
              <p className="text-green-500/80 font-body text-xs md:text-sm flex items-center" data-id="element-47">
                <ShieldCheckIcon className="w-4 h-4 mr-1" data-id="element-48" /> Actualizaciones
                constantes incluidas
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-49">
              <div className="bg-surface-elevated border border-gold/20 rounded-xl p-4 flex items-center space-x-3" data-id="element-50">
                <div className="bg-gold/10 p-2 rounded-lg flex-shrink-0" data-id="element-51">
                  <UsersIcon className="w-6 h-6 text-gold" data-id="element-52" />
                </div>
                <div className="text-left" data-id="element-53">
                  <p className="font-body font-bold text-white text-sm" data-id="element-54">
                    +2,400 hombres
                  </p>
                  <p className="font-body text-[10px] text-gray-400 leading-tight" data-id="element-55">
                    con una efectividad del{' '}
                    <span className="text-gold font-semibold" data-id="element-56">96%</span>
                  </p>
                </div>
              </div>

              <div className="bg-surface-elevated border border-gold/20 rounded-xl p-4 flex items-center space-x-3" data-id="element-57">
                <div className="bg-gold/10 p-2 rounded-lg flex-shrink-0" data-id="element-58">
                  <ShieldCheckIcon className="w-6 h-6 text-gold" data-id="element-59" />
                </div>
                <div className="text-left" data-id="element-60">
                  <p className="font-body font-bold text-white text-sm" data-id="element-61">
                    Garantía 7 días
                  </p>
                  <p className="font-body text-[10px] text-gray-400 leading-tight" data-id="element-62">
                    Devolución del{' '}
                    <span className="text-gold font-semibold" data-id="element-63">100%</span> de tu
                    dinero
                  </p>
                </div>
              </div>

              <div className="bg-surface-elevated border border-green-500/30 rounded-xl p-4 flex items-center space-x-3" data-id="element-64">
                <div className="bg-green-500/10 p-2 rounded-lg flex-shrink-0" data-id="element-65">
                  <LockIcon className="w-6 h-6 text-green-500" data-id="element-66" />
                </div>
                <div className="text-left" data-id="element-67">
                  <p className="font-body font-bold text-green-500 text-sm" data-id="element-68">
                    Pago Seguro
                  </p>
                  <p className="font-body text-[10px] text-green-500/80 leading-tight" data-id="element-69">
                    Con seguridad bancaria encriptada
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}